const redirectTo = (value) => {
  window.location.href = `${process.env.REACT_APP_STORYTALE_APP}/${value}`;
}

export default redirectTo;